import React, { useEffect, useRef } from 'react';
import moment from 'moment';
import { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux';

import axios from 'axios';

import { useNavigate } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import { selectToken } from '../utility/Redux/security';
import { selectPrefix } from '../utility/Redux/profile';
import {
  selectCustomerMasterHelpModStatus,
  setCustomerMasterHelpModStatus,
  setModCustomerMasterModifyStatus,
  setSessionExpired,
  setSpinnerLoading,
} from '../utility/Redux/modal';
import { FormatNumber2 } from '../utility/component/tools';
import { CollectionFromToDate } from '../utility/component/collectionFromToDate';
import { CollectionFromToDateMobile } from '../utility/component/collectionFromToDateMobile';
import CustomerMasterhelp from '../help/customermasterHelp';
import PrintBookingHistory from './printBookingHistory';
import { CallAPIPromise } from '../utility/func/func';

const width = window.innerWidth / 100;

const HistoryReport = () => {
  const token = useSelector(selectToken);
  const prefix = useSelector(selectPrefix);
  const dispatch = useDispatch();
  const [firstDate, setFirstDate] = useState(moment().format('YYYY-MM-DD'));
  const [SecondDate, setSecondDate] = useState(moment().format('YYYY-MM-DD'));
  const [list, setList] = useState([]);
  const [bookingCustomerDetails, setBookingCustomerDetails] = useState({
    code: '',
    customer_name: '',
    mobile: '',
    mobile_2: '',
    mobile_3: '',
    phone: '',
    email: '',
    address: '',
    city: '',
    state: '',
    country: '',
    pin_code: '',
    credit_limit: 100000,
    company_name: '',
    company_phone: '',
    company_email: '',
    company_address: '',
    company_city: '',
    company_state: '',
    company_country: '',
    company_pincode: '',
    regd_no1: '',
    regd_no2: '',
    regd_no3: '',
    status: 'Good',
    remarks: '',
  });

  const customerMasterModalStatus = useSelector(
    selectCustomerMasterHelpModStatus
  );

  const customerDetails = (params) => {
    setBookingCustomerDetails(params.row);
    dispatch(setCustomerMasterHelpModStatus(false));
  };

  const columns = [
    {
      field: 'DATE',
      accessor: 'DATE',
      type: 'date',
      valueFormatter: (params) => {
        if (params.value) {
          return moment(params.value).format('DD-MM-YYYY');
        } else {
          return '';
        }
      },
      width: 120,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Date'}
        </div>
      ),
    },
    {
      field: 'CUSTOMER_NAME',
      accessor: 'CUSTOMER_NAME',
      type: 'string',
      width: 180,
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Name'}
        </div>
      ),
    },

    {
      field: 'MOBILE',
      accessor: 'MOBILE',
      type: 'string',
      width: 132,
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Mobile'}
        </div>
      ),
    },

    {
      field: 'MOBILE_2',
      accessor: 'MOBILE_2',
      type: 'number',
      width: 132,
      headerAlign: 'center',
      align: 'left',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Mobile 2'}
        </div>
      ),
    },

    {
      field: 'MOBILE_3',
      accessor: 'MOBILE_3',
      type: 'string',
      width: 132,
      headerAlign: 'center',
      align: 'right',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Phone'}
        </div>
      ),
    },
    {
      field: 'MRC_NO',
      accessor: 'MRC_NO',
      type: 'string',
      width: 100,
      headerAlign: 'center',
      align: 'left',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Mrc No.'}
        </div>
      ),
    },
    {
      field: 'BOOKING_ORDER_NO',
      accessor: 'BOOKING_ORDER_NO',
      type: 'string',
      width: 130,

      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Booking Order'}
        </div>
      ),
    },
    {
      field: 'STATE',
      accessor: 'STATE',
      type: 'string',
      width: 130,
      valueFormatter: (params) => {
        if (params.value) {
          return params.value;
        } else {
          return '';
        }
      },
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'State'}
        </div>
      ),
    },
    {
      field: 'TRY_DATE',
      accessor: 'TRY_DATE',
      type: 'date',
      valueFormatter: (params) => {
        if (params.value) {
          return moment(params.value).format('DD-MM-YYYY');
        } else {
          return '';
        }
      },
      width: 120,

      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Try Date'}
        </div>
      ),
    },
    {
      field: 'DEL_DATE',
      accessor: 'DEL_DATE',
      type: 'date',
      valueFormatter: (params) => {
        if (params.value) {
          return moment(params.value).format('DD-MM-YYYY');
        } else {
          return '';
        }
      },
      width: 120,

      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Del. Date'}
        </div>
      ),
    },
    {
      field: 'CUTTING_DATE',
      accessor: 'CUTTING_DATE',
      type: 'date',
      valueFormatter: (params) => {
        if (params.value) {
          return moment(params.value).format('DD-MM-YYYY');
        } else {
          return '';
        }
      },
      width: 130,

      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Cutting Date'}
        </div>
      ),
    },
  ];

  const columnsTab = [
    {
      field: 'VOUCHER_NO',
      accessor: 'VOUCHER_NO',
      type: 'number',
      width: width * 10,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'V No.'}
        </div>
      ),
    },
    {
      field: 'DATE',
      accessor: 'DATE',
      type: 'string',
      width: width * 12,
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      valueFormatter: (params) => {
        if (params.value) {
          return moment(params.value).format('DD-MM-YYYY');
        } else {
          return '';
        }
      },

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Date'}
        </div>
      ),
    },
    {
      field: 'CUSTOMER_NAME',
      accessor: 'CUSTOMER_NAME',
      type: 'string',
      width: width * 20,
      headerAlign: 'center',
      align: 'left',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Customer Name'}
        </div>
      ),
    },

    {
      field: 'MOBILE',
      accessor: 'MOBILE',
      type: 'string',
      width: width * 20,
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Mobile'}
        </div>
      ),
    },

    {
      field: 'DEBIT',
      accessor: 'DEBIT',
      type: 'string',
      width: width * 10,
      headerAlign: 'center',
      align: 'right',
      valueFormatter: (params) => {
        if (params.value) {
          return FormatNumber2(params.value);
        } else {
          return '';
        }
      },
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Debit'}
        </div>
      ),
    },
    {
      field: 'CREDIT',
      accessor: 'CREDIT',
      type: 'string',
      width: width * 10,
      headerAlign: 'center',
      align: 'right',
      valueFormatter: (params) => {
        if (params.value) {
          return FormatNumber2(params.value);
        } else {
          return '';
        }
      },
      headerClassName: 'super-app-theme--header',

      renderHeader: (params) => (
        <div className="whitespace-normal leading-4 flex justify-center items-center">
          {'Credit'}
        </div>
      ),
    },
  ];

  const columnsMobile = [
    {
      field: 'DATE',
      type: 'string',
      width: 118,
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      valueFormatter: (params) => {
        if (params.value) {
          return moment(params.value).format('DD-MM-YYYY');
        } else {
          return '';
        }
      },
      renderHeader: (params) => <div style={{ fontSize: 12 }}>{'Date'}</div>,
    },
    {
      field: 'BOOKING_ORDER_NO',
      type: 'string',
      width: 112,
      headerAlign: 'center',
      align: 'center',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div className="whitespace-normal text-center text-xs leading-4">
          Booking Order
        </div>
      ),
    },
    {
      field: 'CUSTOMER_NAME',
      type: 'string',
      width: 180,
      headerAlign: 'center',
      align: 'left',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div
          style={{ fontSize: 12 }}
          className="whitespace-normal leading-4 flex text-center"
        >
          {'Customer Name'}
        </div>
      ),
    },
    {
      field: 'MOBILE',
      type: 'string',
      width: 132,
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      renderHeader: (params) => (
        <div style={{ fontSize: 12 }}>{'Mobile'}</div>
      ),
    },
    {
      field: 'DEL_DATE',
      type: 'date',
      width: 118,
      headerAlign: 'center',
      headerClassName: 'super-app-theme--header',
      valueFormatter: (params) =>
        params.value ? moment(params.value).format('DD-MM-YYYY') : '',
      renderHeader: (params) => <div style={{ fontSize: 12 }}>Delivery</div>,
    },
  ];
  const loadVocherAPI = (invNo) => {
    const data = {
      table_prefix: prefix,
      FDATE: firstDate,
      TDATE: SecondDate,
      MOBILE: bookingCustomerDetails.mobile,
    };

    dispatch(setSpinnerLoading('Loading'));
    CallAPIPromise(`/api/reportRoute/bookingReport`, data)
      .then(async function (response) {
        if (!response.data.error) {
          const data = response.data.response;
          const l = data.map((e, i) => {
            return {
              ...e,
              id: i,
            };
          });
          setList(l);
        }
      })
      .catch(function (error) {
        if (error.response.data.name === 'TokenExpiredError') {
          dispatch(setSessionExpired(true));
        }
        console.log(error);
      })
      .finally(() => {
        dispatch(setSpinnerLoading(false));
      });
  };

  const printRef = useRef();
  const navigate = useNavigate();
  const thermalPrintRef = useRef();
  const [selectedPrintOption, setSelectedPrintOption] = useState('print');
  const [windowSize, setWindowSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowSize(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowSize <= 800;
  const gridColumns = isMobile ? columnsMobile : columns;
  const uniqueCustomers = new Set(
    list.map((row) => row.MOBILE || row.CUSTOMER_NAME).filter(Boolean)
  ).size;
  const trialCount = list.filter((row) => row.TRY_DATE).length;
  const deliveryCount = list.filter((row) => row.DEL_DATE).length;
  const tableHeight = Math.min(460, Math.max(180, 112 + list.length * 42));

  const handlePrint = useReactToPrint({
    content: () =>
      selectedPrintOption === 'print'
        ? printRef.current
        : thermalPrintRef.current,
    pageStyle: `
      @page { size: A4 landscape; margin: 10mm; }
      @media print {
        body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
      }
    `,
    onAfterPrint: () => {
      navigate('/booking_history');
      setSelectedPrintOption('print');
    },
  });

  const summaryCards = [
    {
      label: 'Total Bookings',
      value: list.length,
      detail:
        list.length === 1 ? '1 booking found' : `${list.length} bookings found`,
      icon: 'bi-receipt',
      tone: 'text-[#f08a4b]',
      iconBg: 'bg-[#fff2e8]',
    },
    {
      label: 'Customers',
      value: uniqueCustomers,
      detail: 'Unique customers',
      icon: 'bi-people',
      tone: 'text-[#f5874f]',
      iconBg: 'bg-[#fff0e7]',
    },
    {
      label: 'Trials Scheduled',
      value: trialCount,
      detail: 'Bookings with trial dates',
      icon: 'bi-calendar2-check',
      tone: 'text-[#8dbb28]',
      iconBg: 'bg-[#f1f8df]',
    },
    {
      label: 'Deliveries Scheduled',
      value: deliveryCount,
      detail: 'Bookings with delivery dates',
      icon: 'bi-calendar2-event',
      tone: 'text-[#a6405c]',
      iconBg: 'bg-[#fbe8ed]',
    },
  ];

  return (
    <div
      className={`flex h-full min-h-0 min-w-0 w-full flex-col overflow-x-hidden bg-[#fff9f6] p-3 ${
        isMobile ? 'overflow-y-auto' : 'overflow-y-hidden'
      }`}
    >
      <div className="mb-3 grid shrink-0 grid-cols-2 gap-3 xl:grid-cols-4">
        {summaryCards.map((card) => (
          <div
            key={card.label}
            className="flex min-w-0 items-center rounded-md border border-[#eadbd4] bg-white px-4 py-3 shadow-[0_2px_8px_rgba(31,45,61,0.04)]"
          >
            <div
              className={`mr-3 flex h-9 w-9 shrink-0 items-center justify-center rounded-full ${card.iconBg} ${card.tone}`}
            >
              <i className={`bi ${card.icon}`}></i>
            </div>
            <div className="min-w-0">
              <div className="truncate text-xs font-medium text-[#6b6260]">
                {card.label}
              </div>
              <div className={`truncate text-lg font-bold ${card.tone}`}>
                {card.value}
              </div>
              <div className="truncate text-[11px] text-[#8b7f7a]">
                {card.detail}
              </div>
            </div>
          </div>
        ))}
      </div>

      {isMobile ? (
        <div className="min-w-0 shrink-0">
          <CollectionFromToDateMobile
            setFirstDate={setFirstDate}
            firstDate={firstDate}
            SecondDate={SecondDate}
            setSecondDate={setSecondDate}
            onOkClick={loadVocherAPI}
            printButton={
              <button
                type="button"
                onClick={handlePrint}
                disabled={!list.length}
                className="flex h-[30px] items-center justify-center gap-2 rounded-md border border-[#f5874f] px-4 text-sm font-semibold text-[#f5874f] disabled:cursor-not-allowed disabled:opacity-45"
              >
                <i className="bi bi-printer"></i>
                Print
              </button>
            }
            reset={() => {
              setBookingCustomerDetails({ customer_name: '', mobile: '' });
            }}
            bookingCustomerDetails={bookingCustomerDetails}
          />
        </div>
      ) : (
        <div className="min-w-0 shrink-0">
          <CollectionFromToDate
            setFirstDate={setFirstDate}
            firstDate={firstDate}
            SecondDate={SecondDate}
            setSecondDate={setSecondDate}
            onOkClick={loadVocherAPI}
            printButton={
              <button
                type="button"
                onClick={handlePrint}
                disabled={!list.length}
                className="flex h-12 items-center justify-center gap-2 rounded-md border border-[#f5874f] px-5 text-sm font-semibold text-[#f5874f] transition hover:bg-[#fff2eb] disabled:cursor-not-allowed disabled:opacity-45"
              >
                <i className="bi bi-printer"></i>
                Print
              </button>
            }
            reset={() => {
              setBookingCustomerDetails({ customer_name: '', mobile: '' });
            }}
            bookingCustomerDetails={bookingCustomerDetails}
            reportLayout
          />
        </div>
      )}

      <div
        className={`mt-3 flex min-h-0 min-w-0 flex-col max-sm:mt-2 ${
          isMobile ? 'shrink-0' : 'flex-1'
        }`}
      >
        <div className="flex min-h-0 min-w-0 flex-1 flex-col">
          <div
            className={`min-h-[180px] min-w-0 overflow-hidden ${
              isMobile ? 'shrink-0' : 'flex-1'
            }`}
            style={isMobile ? { height: tableHeight } : undefined}
          >
            <DataGrid
              sx={{
                height: '100%',
                width: '100%',
                minWidth: 0,
                borderRadius: '6px',
                backgroundColor: 'white',
                border: '1px solid #eadbd4',
                fontSize: 14,
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: '#f8e4dc',
                  color: '#383535',
                  borderBottom: '2px solid #f5874f',
                },
                '& .MuiDataGrid-columnHeader': {
                  backgroundColor: '#f8e4dc',
                  borderRight: '1px solid #eadbd4',
                },
                '& .MuiDataGrid-columnHeaderTitle': {
                  fontWeight: 700,
                  fontSize: '12px',
                  letterSpacing: '0.025em',
                  overflow: 'visible',
                  textOverflow: 'clip',
                },
                '& .super-app-theme--header': {
                  backgroundColor: '#f8e4dc',
                },
                '& .MuiDataGrid-cell': {
                  borderRight: '1px solid #f0e3dd',
                  borderBottom: '1px solid #f5ebe6',
                  color: '#4b4545',
                },
                '& .MuiDataGrid-row:hover': {
                  backgroundColor: '#fff2eb',
                },
                '& .MuiDataGrid-row:nth-of-type(even)': {
                  backgroundColor: '#fffaf7',
                },
                '& .MuiDataGrid-footerContainer': {
                  borderTop: '1px solid #eadbd4',
                  color: '#6b6260',
                },
                '& .MuiDataGrid-virtualScroller': {
                  overflowX: 'auto',
                  overflowY: 'auto',
                  overscrollBehavior: 'contain',
                },
              }}
              rowHeight={42}
              headerHeight={46}
              columns={gridColumns}
              rows={list}
              pagination
              scrollbarSize={8}
              rowsPerPageOptions={[100]}
              experimentalFeatures={{ newEditingApi: true }}
              showCellRightBorder={true}
              showColumnRightBorder={true}
              disableColumnSelector
              disableColumnReorder
              disableColumnMenu={true}
              components={{
                NoRowsOverlay: () => (
                  <div className="flex h-full w-full flex-col items-center justify-center text-ggray">
                    <i className="bi bi-calendar2-x mb-2 text-2xl opacity-60"></i>
                    <span className="font-medium">No booking history found</span>
                    <span className="mt-1 text-xs">
                      Change the date range or customer and apply the filter.
                    </span>
                  </div>
                ),
              }}
            />
          </div>
          <div className="mt-2 flex min-h-[48px] shrink-0 items-center justify-between rounded-md border border-[#eadbd4] bg-white px-4 text-sm text-[#6b6260]">
            <span>{list.length} booking record(s)</span>
            <span className="font-semibold text-[#514946]">
              {bookingCustomerDetails.mobile
                ? `Filtered by ${bookingCustomerDetails.customer_name || bookingCustomerDetails.mobile}`
                : 'All customers'}
            </span>
          </div>
        </div>
      </div>

      <CustomerMasterhelp
        onRowClick={(params) => {
          if (customerMasterModalStatus) {
            customerDetails(params);
          }
          dispatch(setModCustomerMasterModifyStatus(false));
        }}
      />

      <div className="hidden">
        {selectedPrintOption === 'print' && windowSize ? (
          <div
            ref={printRef}
            style={{ display: 'block', visibility: 'hidden' }}
          >
            <PrintBookingHistory
              data={list}
              firstDate={firstDate}
              SecondDate={SecondDate}
              bookingCustomerDetails={bookingCustomerDetails}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default HistoryReport;
